<template>
  
 
    <div>

           <div class="absolute w-full" v-if="loading">

                <ring-loader class="rounded-full" ></ring-loader> 
            </div>
        <button class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease" v-on:click="toggleModal()">
        {{$t('search.jointPrivateGroup')}}
        </button>
        <div v-if="showModal" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-auto my-6 mx-auto max-w-sm">
                <!--content-->
                <div class="bg-pink-600 border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                <!--header-->
                <div class="flex flex-row items-center justify-center p-5 border-b border-solid border-gray-300 rounded-t">
                    <h3 class="text-3xl font-semibold text-center">
                    {{$t('search.insertCode')}}
                    </h3>
                </div>
                <!--body-->
                <div class="flex flex-col items-center justify-center relative p-6 flex-auto bg-blue-400">

                    <div class="bg-white mb-2 lg:mb-5 w-20 rounded lg:rounded-lg">

                        <label>{{$t('search.insertCode')}} </label>
                    </div>
                    <div class=" ">
                                                
                        <input type="text"  v-model="businessCode"
                        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2
                         px-4 block appearance-none leading-normal text-center w-40 lg:w-64"
                        />
                    </div> 

                </div>
                <!--footer-->
                <div class="bg-white flex items-center justify-around p-6 border-t border-solid border-gray-300 rounded-b">
                    <button class="businessFormButton" type="button" style="transition: all .15s ease"
                       v-on:click="toggleModal()">
                    {{$t('profile.close')}}
                    </button>
                    <button class="text-white  bg-blue-600 rounded lg:rounded-lg font-bold 
                    uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1" 
                    type="button" style="transition: all .15s ease" v-on:click="submitRequest()">
                    {{$t('profile.submit')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
        <div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black">

        </div>
    </div>
</template>

<script>

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import componentsHelpers from '../classes/componentHelpers';
export default {

    props:{

        userId: 0,

        reload: {

            type: Function 
        }
    },

  data() {
    return {
        
        showModal: false,

        businessCode: '',
        
        loading: false,
    }
  },
  methods: {

    toggleModal: function(){
      this.showModal = !this.showModal;
    },

    async submitRequest(){

        // console.log(`start request with ${this.businessCode.length}`)
        if(this.businessCode.length > 16)
        {

            try{

                this.loading = true;

                console.log(`userId : ${this.userId}`);

                let result = await axios({method: 'post',url: '/pnadiapi/business/addPrivateBusiness',
                    data: {
                        
                        businessUUID: this.businessCode,
                        userId: this.userId,
                    }});

                    if(result.status == 200){

                        componentsHelpers.toastIt(this.$toasted, this.$t('search.successfulOperation'), 2, 'bubble', true);

                        const reload = this.reload;

                        setTimeout(function(){

                            reload();
                        }, 3000);

                        this.showModal = false;

                    }else if(result.status == 204){

                        componentsHelpers.toastIt(this.$toasted, this.$t('payment.invalidCode'), 3, 'toasted-primary', true)
                    }
                    this.loading = false;
            }catch(error){

                this.loading = false;

                componentsHelpers.sendError(this.$apollo, this.userId,'Search', 'addPrivate', 'submitRequest', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('payment.invalidCode'), 3, 'outline', true)
            }
        }
        else{
            
            componentsHelpers.toastIt(this.$toasted, this.$t('payment.enterProperCode'), 3, 'outline', true);
        }
    }
  },


}
</script>

<style>

</style>